import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'

import { formatearFecha } from '../../helpers/helper'
import Precios from '../precios/Precios'
import styles from './ComisionPublicacion.module.css'
import pedidoStyles from './Pedido.module.css'

export const ComisionPublicacion = ({ pedido }) => {
  const navigate = useNavigate()
  const item = pedido.pedidoItems?.[0] ?? {}
  const monto = Number(item.precioUnitario) || 0
  const razonSocial = (item.razonSocial ?? item.RazonSocial)?.trim()
  const fecha = formatearFecha(pedido.ordenSecundario ?? pedido.fechaPedido, 'F')

  return (
    <div className={`${pedidoStyles.pedido} ${styles.comision}`}>
      <div className={`${pedidoStyles.cabecera} ${styles.cabecera}`}>
        <h3 className={pedidoStyles.titulo}>
          <button
            type="button"
            className={styles.titulo}
            onClick={() => navigate(`/Publicacion/${item.idPublicacion}`)}
          >
            Aviso Nº {item.idPublicacion} — {item.titulo}
          </button>
          <span className={pedidoStyles.presupuestoReferencia}>
            {item.vendedorNombre}
            {razonSocial && ` (${razonSocial})`}
            {fecha && ` · ${fecha}`}
          </span>
        </h3>

        <div>
          <Precios
            precio={monto}
            monedaSimbolo={item.monedaSimbolo}
            className={pedidoStyles.precioCabecera}
            classNameValor={styles.monto}
          />
        </div>
      </div>
    </div>
  )
}

ComisionPublicacion.propTypes = {
  pedido: PropTypes.shape({
    fechaPedido: PropTypes.string,
    ordenSecundario: PropTypes.string,
    pedidoItems: PropTypes.arrayOf(
      PropTypes.shape({
        idPublicacion: PropTypes.number,
        titulo: PropTypes.string,
        vendedorNombre: PropTypes.string,
        razonSocial: PropTypes.string,
        RazonSocial: PropTypes.string,
        monedaSimbolo: PropTypes.string,
        precioUnitario: PropTypes.number
      })
    )
  }).isRequired
}
